<style lang="less">
    @import "../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;height: 100%; min-height: 726px;background: #fff;">
       <div class="table-list" style="">
            <div class="table-list-title">
                <span class="myTitle">支付记录</span>
                <div class="choose-group">
                    <span class="choose-group-span">时间</span>
                    <Date-picker @on-change="changeDate" :value="value2" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px"></Date-picker>
                    <span class="choose-group-span">订单状态</span>
                    <i-select v-model="model1" placeholder="全部" style="width:126px" @on-change="selectType">
                        <i-option v-for="(item,index) in payList" :key="index" :value="index">{{ item }}</i-option>
                    </i-select>
                    <span class="choose-group-span">购买服务</span>
                    <i-select v-model="model2" placeholder="全部" style="width:126px" @on-change="selectType2">
                        <i-option v-for="(item,index) in fuwuList" :key="index" :value="item.num">{{ item.text }}</i-option>
                    </i-select>
                    <div @click="addworkname" class="btn-84 addBtn">查询</div>
                </div>
            </div>
            <Row class="table-style-size">
                <i-col span="5">订单号</i-col>
                <i-col span="2">购买服务</i-col>
                <i-col span="2">订单金额</i-col>

                <i-col span="2">付款方式</i-col>
                <i-col span="2">订单状态</i-col>
                <i-col span="2">订单创建时间</i-col>
                <i-col span="2">订单支付时间</i-col>
                <i-col span="5">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
                    <i-col span="5">{{item.paySeqNo}}</i-col>
                    <i-col span="2">{{item.subBizType}}</i-col>
                    <i-col span="2">{{(item.payAmount / 100).toFixed(2)}}</i-col>

                    <i-col span="2">
                        <div v-if="item.payStatus != 'unpay'">
                            {{item.payWay == 'WechatPay'?'微信支付':'支付宝支付'}}
                        </div>
                        <div v-else>--</div>
                    </i-col>
                    <i-col span="2">
                        <span v-if="item.payStatus == 'unpay'">未支付</span>
                        <span v-if="item.payStatus == 'cancel'">已取消</span>
                        <span v-if="item.payStatus == 'paid'">已支付</span>
                        <span v-if="item.payStatus == 'refund'">已退款</span>
                        <span v-if="item.payStatus == 'refunding'">退款中</span>
                        <span v-if="item.payStatus == 'regular-clearing'">第三方</span>
                    </i-col>
                    <i-col span="2">{{item.createDate}}</i-col>
                    <i-col span="2">{{item.payDate == null ? '--':item.payDate}}</i-col>
                    <i-col span="5">
                        <button class="btn-84 addBtn" style="margin:0 10px 0 0" @click="goPay(item)" v-if='item.payStatus =="unpay"'>去支付</button>
                        <button class="btn-84 addBtn" style="margin:0" @click="quxiaoOrder(item)" v-if='item.payStatus =="unpay"'>取消订单</button>
                        <button class="btn-84 addBtn" style="margin:0" @click="deleteOrder(item)" v-if='item.payStatus =="cancel"'>删除订单</button>
                    </i-col>
                </Row>
                <div style="height:80px"></div>
                <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                    <Page :page-size="pageSize" :current="pageNumber" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                    <span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>

            <div class="empty-box" v-if="records.length<=0">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>
        <logindDalog ref="logindDalog" :dataObj="dataObj" @confirm="confirmDalog"></logindDalog>
        <!-- 前海版权公共服务平台支付 -->
        <payDalog ref="payDalog" :payOrder="payOrder" @confirm="confirm"></payDalog>
    </div>
</template>

<script>
import {getByPageGangAn,cancelByPaySeqNo} from '@/api/staticPage';
import Cookies from "js-cookie";
import EventBus from "@/libs/eventBus"
import logindDalog from "@/viewsGangAn/components/logindDalog"
import { _cancelOrder,_deleteOrderByIds,_countOrder} from "@/api/wallet.js";
import payDalog from '@/viewsGangAn/components/payDalog2';
export default {
  metaInfo: {
    title: '支付记录|前海版权综合服务平台',
    meta: [{                 // set meta
      name: 'keyWords',
      content: '版权服务,版权百科,版权,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
    }, {
      name: 'Description',
      content: '会员信息,前海版权服务平台,人人都是创作者，人人都是版权人。前海版权服务平台秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
    }]
  },
    name:'MyOrder',
    components:{
        logindDalog,
        payDalog
    },
    data() {
        return {
            records:[],
            total: 0,
            pageSize: 8,
            pageNumber: 1,
            startDate: '',
            endDate: '',
            value2: [],
            payStatus: '',
            model1: 'all',
            model2: 'all',
            payList: {
                all:"全部",
                unpay:"待支付",
                paid:"已支付",
                cancel:"已取消",
                refund:"已退款",
            },
            fuwuList: [
                {
                    text:"全部",
                    num: 'all'
                },
                {
                    text:"版权登记(5-7工作日)",
                    num: '020303'
                },
                {
                    text:"登记加急(3工作日)",
                    num: '020302'
                },
                {
                    text:"登记加急(1工作日)",
                    num: '020301'
                },
                {
                    text:"预登记",
                    num: '1701'
                },
                {
                    text:"电子数据存证",
                    num: '0102'
                },
                {
                    text:"网页取证",
                    num: '0301'
                },
            ],
            pages: 0,
            dataObj: {
                title:'取消订单',
                content:'是否取消订单',
                dalogType: 0
            },
            delData: {},
            subBizType: '',
            payOrder: '',
            paySeqNoQuxiao: ''
        }
    },
    methods: {
        goPay(data){
            console.log(data);
            this.$refs.payDalog.getPayInfoByPaySeqNo(data)
        },
        confirm(e,orderType) {
            this.getByPage()
        },
        confirmDalog(e){
            if (e.dalogType == 0) {
                let data = {
                    paySeqNo: this.paySeqNoQuxiao
                }
                cancelByPaySeqNo(data).then(res => {
                    if(res.code == 200){
                        toast('订单已取消')
                        this.getByPage();
                        this.$refs.logindDalog.closeDialog()
                    }
                })
            } else {
               _deleteOrderByIds(this.delData.id).then(res => {
                    if(res.code == 200){
                        toast('删除成功')
                        this.getByPage();
                        this.$refs.logindDalog.closeDialog()
                    }
                })
            }
        },
        quxiaoOrder(data){
            // this.$Spin.show();
            let _this = this;
            _this.dataObj = {
                title:'取消订单',
                content:'是否取消订单',
                dalogType: 0
            }
            _this.paySeqNoQuxiao = data.paySeqNo
            _this.$refs.logindDalog.closeDialog()
            return false
            _cancelOrder(data.orderSeqNo).then(res => {
                this.$Spin.hide();
                if(res.code == 200){
                    toast(res.result)
                    this.getByPage();
                    //获取是否有未支付的订单
                    _countOrder().then(res=>{
                        if(res.code == 200){
                            console.log(res)
                            Cookies.set("countOrderNum",res.result);
                            _this.setStore("countOrderNum", res.result);
                            _this.$nextTick(()=>{
                                EventBus.emit("countOrderNumFn", JSON.stringify(res.result))
                            })

                        }
                    })
                }
            })
        },
        deleteOrder(data){
            this.dataObj = {
                title:'删除订单',
                content:'是否删除订单',
                dalogType: 1
            }
            this.delData = data
            this.$refs.logindDalog.closeDialog()

        },
        getByPage() {
            let _this = this;
            const data = {
                pageNumber: _this.pageNumber,
                pageSize: 9,
                sort: 'create_date',
                order: 'desc',
                payStartDate: _this.startDate,
                payEndDate: _this.endDate,
                payStatus: _this.payStatus,
                bizType: '',
                subBizType: _this.subBizType
            }
            getByPageGangAn(data).then(res => {
                if (res.code == 200) {
                    _this.total = Number(res.result.total);
                    _this.pages = Number(res.result.pages) + 1;
                    _this.records = res.result.records;
                    // _this.flag = true;
                }
            });
        },
        changeDate(starttime, endtime) {
            this.startDate = starttime ? starttime[0] : '';
            this.endDate = starttime ? starttime[1] : '';
            this.pageNumber = 1;
            this.getByPage();
        },
        selectType(val) {
            console.log('这是获取的类型', val)
            this.payStatus = val == 'all' ? '' : val;
            this.pageNumber = 1;
            this.getByPage();
        },
        selectType2(val) {
            console.log('这是获取的类型', val)
            this.subBizType = val == 'all' ? '' : val;
            this.pageNumber = 1;
            this.getByPage();
        },

        addworkname() {
            this.pageNumber = 1;
            this.getByPage();
        },
        changepage(index) {
            this.pageNumber = index;
            this.getByPage();
        },
    },
    mounted() {
        this.getByPage();
    },
    watch: {
    }
}
</script>
<style scoped lang="less">


</style>
